import React from 'react'
var BlogHeaders={
    backgroundImage: 
    "url('/images/BannerImages/bloghero.jpg')",
    marginTop:"0px"
  }
export default function BlogHero() {
  return (
    <>
      
<section id="Blog-hero" style={BlogHeaders}>
    <h2>#Readmore</h2>    
    <p>Read all case studies about our product carefully</p>


</section>

    </>
  )
}
